<template>
  <div v-if="tour">

    <!-- Tour Details -->
    <form class="form" v-on:submit.prevent="updateTour">
      <h1>Tour: {{ tour.name }}</h1>
      <div class="box">
        <Errors/>
        <TourFields 
          :countries="countries" 
          :bonding_types="bondingTypes" 
        />
        <div class="form-wrap form-submit">
          <div class="mt-1" v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div class="mt-1" v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update tour</span></button>
          </div>
        </div>
      </div>
    </form>

    <!-- Tour Group Start -->
      <TourGroups :tour_type="tour.tour_type" :regions="regions"/>
    <!-- Tour Group End -->
    
    <!-- Accommodation -->
    <template>
      
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-12 m-3">
            <h3> Accommodation <ShowHideEye :showSection="showAccomSection" @toggle="showAccomSection = !showAccomSection"/> </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="showAccomSection">
            <form class="form" v-on:submit.prevent="addAccommodation">
              <fieldset>
                <div class="form-wrap">
    
                  <div>
                    <label>Accommodation</label>
                    <v-select
                      v-model="newAccommodation.accommodation_id"
                      label="accommodation_name"
                      id="accommodation"
                      :options="accommodations"
                      index="id"
                      v-if="accommodations.length > 0"
                    />
                  </div>
    
                  <div>
                    <label for="check_in_day">Check-in day</label>
                    <input id="check_in_day" type="number" v-model="newAccommodation.check_in_day" :min="1" :max="tour.duration + 1" required>
                  </div>
    
                  <div>
                    <label for="check_out_day">Check-out day</label>
                    <input id="check_out_day" type="number" v-model="newAccommodation.check_out_day" :min="1" :max="tour.duration + 1" required>
                  </div>
    
                  <div class="form-submit-inline">
                    <template v-if="this.getLoadStatus">
                      <button type="submit" class="button" disabled><span>Adding accommodation...</span></button>
                    </template>
                    <template v-else>
                      <button type="submit" class="button" v-if="userRole == 1"><span>Add accommodation</span></button>
                    </template>
                  </div>
    
                </div>
              </fieldset>
            </form>
            <table v-if="tour.accommodation" class="table" cellspacing="0" cellpadding="0">
              <thead v-if="tour.accommodation.length > 0">
                <tr>
                  <th>Accommodation name</th>
                  <th>Check-in day</th>
                  <th>Check-out day</th>
                  <th>Special Accommodation</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="accommodation of tour.accommodation" :key="accommodation.id" :class="{'is-special-accommodation': accommodation.is_special_accommodation}">
                  <td>{{ accommodation.details.accommodation_name }}</td>
                  <td>{{ accommodation.check_in_day }}</td>
                  <td>{{ accommodation.check_out_day }}</td>
                  <td>{{ accommodation.is_special_accommodation }}</td>
                  <td class="table-action" v-if="accommodation.is_special_accommodation"><a v-on:click="editAccommodation(accommodation.id)" class="icon icon--more">Edit</a></td>
                  <td class="table-action dropdown" v-else>
                    <a class="nav-link dropdown-toggle icon icon--more" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      <li><a class="dropdown-item" href="javascript:void(0);" v-on:click="editAccommodation(accommodation.id)">Edit</a></li>
                      <li><a class="dropdown-item" href="javascript:void(0);" v-on:click="handleExclude(accommodation)">Exclude Accommodation</a></li>
                    </ul>
                  </td>
                  <td class="table-action">
                    <template v-if="userRole == 1">
                      <a v-on:click="deleteAccommodation(accommodation.id)" class="icon icon--delete">Delete</a>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!-- / Accommodation -->

    <!-- Extras -->
    <template>
      
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-12 m-3">
            <h3> Tour Extras <ShowHideEye :showSection="showExtraSection" @toggle="showExtraSection = !showExtraSection"/> </h3>
          </div>
        </div>
        <div class="row" v-if="showExtraSection">
          <div class="col-md-12">
            <form class="form" v-on:submit.prevent="addExtra">
              <fieldset>
                <div class="form-wrap">
    
                  <div>
                    <label>Extra Name</label>
                    <input
                      type="text"
                      label="name"
                      id="name"
                      :options="extras"
                      index="id"
                      v-model="newExtra.name"
                  />
                  </div>
    
                  <div>
                    <label for="price">Price</label>
                    <input
                      title="price"
                      id="price"
                      type="number"
                      placeholder="0.00"
                      min="0"
                      step="0.01"
                      v-model="newExtra.price"
                    />
                  </div>
    
                  <div>
                    <label for="cost">Cost</label>
                    <input
                      title="cost"
                      id="cost"
                      type="number"
                      placeholder="0.00"
                      min="0"
                      step="0.01"
                      v-model="newExtra.cost"
                    />
                  </div>
    
                  <div>
                    <label for="stop-sell">Commissionable</label>
                    <label class="switch">
                      <input id="stop-sell" name="stop_sell" type="checkbox" v-model="newExtra.commissionable">
                      <span class="switch__slider"></span>
                    </label>
                  </div>
    
                  <div>
                    <label for="commission_rate">Commission Rate</label>
                    <input
                      title="commission_rate"
                      type="number"
                      id="commission_rate"
                      placeholder="10"
                      v-model="newExtra.commission_rate"
                    />
                  </div>
    
                  <div>
                    <label for="start-date">Start date</label>
                    <input id="start-date" type="date" v-model="newExtra.start_date" required>
                  </div>
    
                  <div>
                    <label for="end-date">End date</label>
                    <input id="end-date" type="date" v-model="newExtra.end_date" required>
                  </div>
    
                  <!-- <input type="hidden" name="tour_id" v-bind="tour_idx" v-model="newExtra.tour_id"> -->
    
                  <div class="form-submit-inline">
                    <template v-if="this.getLoadStatus">
                      <button type="submit" class="button" disabled><span>Adding extra...</span></button>
                    </template>
                    <template v-else>
                      <button type="submit" class="button" v-if="userRole == 1"><span>Add extra</span></button>
                    </template>
                  </div>
    
                </div>
                  <input type="hidden">
              </fieldset>
            </form>
            <table v-if="tour.extras" class="table" cellspacing="0" cellpadding="0">
              <thead v-if="tour.extras.length > 0">
                <tr>
                  <th>Extra Name</th>
                  <th>Price</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="extra of tour.extras" :key="extra.id">
                  <td>{{ extra.name }}</td>
                  <td>{{ extra.price | formatCurrency }}</td>
                  <td>
                    <template v-if="userRole == 1">
                      <a v-on:click="deleteExtra(extra.tour_id)" class="icon icon--delete">Delete</a>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!-- / Extras -->
    <div class="modal" v-if="showExcludedAccommodation" style="display: block;height:fit-content">
      <h1>Accommodation: {{ editedAccommodation.details.accommodation_name }}</h1>
      <div class="box">
        <table class="table" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th>Groups</th>
              <th>Excluded</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="group of tour.groups" :key="group.id">
               <td>{{ group.start_date | formatDate }}</td>
              <td>
                <label class="switch">
                  <input id="stop-sell" type="checkbox" :checked="isExcluded(group)" @change="toggleAccommodationExclude($event, group)">
                  <span class="switch__slider"></span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="icon icon--unlink" v-on:click="showExcludedAccommodation = false">Close</button>
    </div>
  </div>
</template>

<script>
import TourFields from '@/components/TourFields.vue'
import ShowHideEye from "@/components/ShowHideEye.vue";
import TourGroups from '@/components/Tour/TourGroups.vue'

import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'TourEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    dateLabel() {
      return (this.tour.tour_type == 'air' ? 'Departure Date' : 'Pickup Date')
    },
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showGroupSection = true
        this.showAccomSection = true
        this.showExtraSection = true
      }
      return user_role
    },
  },
  data () {
    return {
      tour: null,
      countries: null,
      airports: null,
      extras: [],
      accommodations: [],
      regions: [],
      errors: null,
      newGroup: {
        tour_id: this.$route.params.id,
      },
      newAccommodation: {
        tour_id: this.$route.params.id,
      },
      newExtra: {
        tour_id: this.$route.params.id,
      },
      showExcludedAccommodation: false,
      editedAccommodation: {},
      showGroupSection:false,
      showAccomSection:false,
      showExtraSection: false,
      countries:[],
      bondingTypes:[],
    }
  },
  components: {
    TourFields,
    Errors,
    ShowHideEye,
    TourGroups
  },
  created () {
    this.getTour()
    this.getTourData()
  },
  methods: {
    getTour () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.tour = response.data[0]
      })
    },
    getTourData() {
      fetch(this.$api + 'tours/tour-data', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
        .then(response => {
        this.accommodations = response.data.accomodations
        this.bondingTypes = response.data.bonding_types
        this.countries = response.data.countries
        this.regions = response.data.pickUpRegions
      })
    },
    updateTour (event) {
      this.$store.dispatch('setLoadStatus')

      let formObject = {
        name : this.tour.name,
        reference : this.tour.reference,
        enabled : this.tour.enabled,
        tour_type : this.tour.tour_type,
        deposit_price : this.tour.deposit_price,
        duration : this.tour.duration,
        minimum_age : this.tour.minimum_age,
        release_days_before : this.tour.release_days_before,
        destination : this.tour.destination,
        bonding_type_id : this.tour.bonding_type_id,
        tour_places : this.tour.tour_places,
        stop_sell : this.tour.stop_sell,
        is_suppressed : this.tour.is_suppressed,
        is_passport_details_required : this.tour.is_passport_details_required,
        itinerary : this.tour.itinerary,
        covering_emails : this.tour.covering_emails,
      }

      let formData = new FormData();

      // Iterate through the object
      for (const key in formObject) {
          // Check if the property belongs to the object (not inherited)
          if (formObject.hasOwnProperty(key) && formObject[key]) {
              // Append key-value pair to the FormData object
              formData.append(key, formObject[key]);
          }
      }
      
      // formData.append('tour', JSON.stringify());
      formData.append('information_doc_file', this.tour.tour_info_doc)

      fetch(this.$api + 'tours/' + this.$route.params.id, {
        method: 'POST',
        body: formData,
        headers:{
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          document.getElementById("file-upload").value = "";
          this.getTour();
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    addAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/' + this.$route.params.id + '/accommodation', {
        method: 'POST',
        body: JSON.stringify(this.newAccommodation),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getTour()
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    editAccommodation(accommodationId) {
      this.$router.push({ name: 'tour-accommodation', params: { id: accommodationId }})
    },
   deleteAccommodation(accommodationId) {
      this.$dialog
      .confirm("Are you sure you want to delete this accomodation? Please note that if there is any booking attached to this accomodation through this tour, deletion will be prevented automatically.")
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/accommodation/' + accommodationId + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        }).then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if (response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.getTour()
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus')
        })
      }).catch(() => {
        console.log('Clicked on cancel');
      });
    },
    addExtra () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'extras', {
        method: 'POST',
        body: JSON.stringify(this.newExtra),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getTour()
        }  else {
          this.$notify({
            type: 'error',
            title: response.error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    deleteExtra (extraId) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/extras/' + extraId + '/delete/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getTour()
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    handleExclude(accommodation) {
      this.editedAccommodation = accommodation;
      this.showExcludedAccommodation = true;
    },
    isExcluded(group) {
      const excluded = group.excluded_accommodations.filter(
        excluded_accommodation =>
          excluded_accommodation.accommodation_id ===
            this.editedAccommodation.accommodation_id &&
          excluded_accommodation.tour_accommodation_id === this.editedAccommodation.id
      );

      return excluded.length > 0 ? true : false;
    },
    toggleAccommodationExclude(event, group) {
      this.$dialog
      .confirm('Are you sure you want to exclude the accommodation?')
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/groups/exclude-accommodation', {
          method: 'POST',
          body: JSON.stringify({
            tour_group_id: group.id,
            tour_accommodation_id: this.editedAccommodation.id,
            accommodation_id: this.editedAccommodation.accommodation_id,
            checked: event.target.checked,
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.getTour();
          } else {
            // Reset the checkbox toggle state on error
            event.target.checked = !event.target.checked;
            this.$notify({
              type: 'error',
              title: response.error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      })
      .catch(() => {
        // Reset the checkbox toggle state on error
        event.target.checked = !event.target.checked;
        console.log('Clicked on cancel');
      });
    },
  },
  mounted()
  {
  }
}
</script>
<style scoped>
.is-special-accommodation {
  background: #e8e8e8;
}
</style>
